/*
 * Code generated by Microsoft (R) AutoRest Code Generator.
 * Changes may cause incorrect behavior and will be lost if the code is
 * regenerated.
 */

import * as coreHttp from "@azure/core-http";
import * as Models from "../models";
import * as Mappers from "../models/identityTheftMonitoringSubscriptionMappers";
import * as Parameters from "../models/parameters";
import { MicrosoftConsumerSecurityClientContext } from "../microsoftConsumerSecurityClientContext";

/** Class representing a IdentityTheftMonitoringSubscription. */
export class IdentityTheftMonitoringSubscription {
  private readonly client: MicrosoftConsumerSecurityClientContext;

  /**
   * Create a IdentityTheftMonitoringSubscription.
   * @param {MicrosoftConsumerSecurityClientContext} client Reference to the service client.
   */
  constructor(client: MicrosoftConsumerSecurityClientContext) {
    this.client = client;
  }

  /**
   * Calls external APIs to register a subscription for the user.
   * @summary Registers a subscriber for the user based on the information provided in the user
   * claims.
   * @param [options] The optional parameters
   * @returns Promise<Models.IdentityTheftMonitoringSubscriptionRegisterSubscriberResponse>
   */
  registerSubscriber(options?: coreHttp.RequestOptionsBase): Promise<Models.IdentityTheftMonitoringSubscriptionRegisterSubscriberResponse>;
  /**
   * @param callback The callback
   */
  registerSubscriber(callback: coreHttp.ServiceCallback<Models.RegisterSubscriberApiResponse>): void;
  /**
   * @param options The optional parameters
   * @param callback The callback
   */
  registerSubscriber(options: coreHttp.RequestOptionsBase, callback: coreHttp.ServiceCallback<Models.RegisterSubscriberApiResponse>): void;
  registerSubscriber(options?: coreHttp.RequestOptionsBase | coreHttp.ServiceCallback<Models.RegisterSubscriberApiResponse>, callback?: coreHttp.ServiceCallback<Models.RegisterSubscriberApiResponse>): Promise<Models.IdentityTheftMonitoringSubscriptionRegisterSubscriberResponse> {
    return this.client.sendOperationRequest(
      {
        options
      },
      registerSubscriberOperationSpec,
      callback) as Promise<Models.IdentityTheftMonitoringSubscriptionRegisterSubscriberResponse>;
  }

  /**
   * Calls external APIs to delete the subscriber.
   * @summary Deletes the subscription for the current user.
   * @param [options] The optional parameters
   * @returns Promise<coreHttp.RestResponse>
   */
  deleteSubscriber(options?: Models.IdentityTheftMonitoringSubscriptionDeleteSubscriberOptionalParams): Promise<coreHttp.RestResponse>;
  /**
   * @param callback The callback
   */
  deleteSubscriber(callback: coreHttp.ServiceCallback<void>): void;
  /**
   * @param options The optional parameters
   * @param callback The callback
   */
  deleteSubscriber(options: Models.IdentityTheftMonitoringSubscriptionDeleteSubscriberOptionalParams, callback: coreHttp.ServiceCallback<void>): void;
  deleteSubscriber(options?: Models.IdentityTheftMonitoringSubscriptionDeleteSubscriberOptionalParams | coreHttp.ServiceCallback<void>, callback?: coreHttp.ServiceCallback<void>): Promise<coreHttp.RestResponse> {
    return this.client.sendOperationRequest(
      {
        options
      },
      deleteSubscriberOperationSpec,
      callback);
  }

  /**
   * Calls external APIs to register a subscription for the user.
   * @summary Registers a user based on the information provided.
   * @param [options] The optional parameters
   * @returns
   * Promise<Models.IdentityTheftMonitoringSubscriptionRegisterSubscriberWithPrimaryDataResponse>
   */
  registerSubscriberWithPrimaryData(options?: Models.IdentityTheftMonitoringSubscriptionRegisterSubscriberWithPrimaryDataOptionalParams): Promise<Models.IdentityTheftMonitoringSubscriptionRegisterSubscriberWithPrimaryDataResponse>;
  /**
   * @param callback The callback
   */
  registerSubscriberWithPrimaryData(callback: coreHttp.ServiceCallback<Models.RegisterSubscriberApiResponse>): void;
  /**
   * @param options The optional parameters
   * @param callback The callback
   */
  registerSubscriberWithPrimaryData(options: Models.IdentityTheftMonitoringSubscriptionRegisterSubscriberWithPrimaryDataOptionalParams, callback: coreHttp.ServiceCallback<Models.RegisterSubscriberApiResponse>): void;
  registerSubscriberWithPrimaryData(options?: Models.IdentityTheftMonitoringSubscriptionRegisterSubscriberWithPrimaryDataOptionalParams | coreHttp.ServiceCallback<Models.RegisterSubscriberApiResponse>, callback?: coreHttp.ServiceCallback<Models.RegisterSubscriberApiResponse>): Promise<Models.IdentityTheftMonitoringSubscriptionRegisterSubscriberWithPrimaryDataResponse> {
    return this.client.sendOperationRequest(
      {
        options
      },
      registerSubscriberWithPrimaryDataOperationSpec,
      callback) as Promise<Models.IdentityTheftMonitoringSubscriptionRegisterSubscriberWithPrimaryDataResponse>;
  }

  /**
   * Signal to the backend that the user has completed the onboarding process and has viewed the
   * breach result.
   * @summary Signal that the user has completed the onboarding process.
   * @param [options] The optional parameters
   * @returns Promise<coreHttp.RestResponse>
   */
  onboardingCompleted(options?: coreHttp.RequestOptionsBase): Promise<coreHttp.RestResponse>;
  /**
   * @param callback The callback
   */
  onboardingCompleted(callback: coreHttp.ServiceCallback<void>): void;
  /**
   * @param options The optional parameters
   * @param callback The callback
   */
  onboardingCompleted(options: coreHttp.RequestOptionsBase, callback: coreHttp.ServiceCallback<void>): void;
  onboardingCompleted(options?: coreHttp.RequestOptionsBase | coreHttp.ServiceCallback<void>, callback?: coreHttp.ServiceCallback<void>): Promise<coreHttp.RestResponse> {
    return this.client.sendOperationRequest(
      {
        options
      },
      onboardingCompletedOperationSpec,
      callback);
  }

  /**
   * Relies on CosmosDB to return the subscriber onboarding summary.
   * @summary Retrieves the subscriber onboarding summary for the current user.
   * @param [options] The optional parameters
   * @returns
   * Promise<Models.IdentityTheftMonitoringSubscriptionGetSubscriberOnboardingSummaryResponse>
   */
  getSubscriberOnboardingSummary(options?: coreHttp.RequestOptionsBase): Promise<Models.IdentityTheftMonitoringSubscriptionGetSubscriberOnboardingSummaryResponse>;
  /**
   * @param callback The callback
   */
  getSubscriberOnboardingSummary(callback: coreHttp.ServiceCallback<Models.SubscriberOnboardingSummaryApiResponse>): void;
  /**
   * @param options The optional parameters
   * @param callback The callback
   */
  getSubscriberOnboardingSummary(options: coreHttp.RequestOptionsBase, callback: coreHttp.ServiceCallback<Models.SubscriberOnboardingSummaryApiResponse>): void;
  getSubscriberOnboardingSummary(options?: coreHttp.RequestOptionsBase | coreHttp.ServiceCallback<Models.SubscriberOnboardingSummaryApiResponse>, callback?: coreHttp.ServiceCallback<Models.SubscriberOnboardingSummaryApiResponse>): Promise<Models.IdentityTheftMonitoringSubscriptionGetSubscriberOnboardingSummaryResponse> {
    return this.client.sendOperationRequest(
      {
        options
      },
      getSubscriberOnboardingSummaryOperationSpec,
      callback) as Promise<Models.IdentityTheftMonitoringSubscriptionGetSubscriberOnboardingSummaryResponse>;
  }

  /**
   * Calls external APIs to return the complete subscription profile.
   * @summary Retrieves the complete subscription profile registered for the current user.
   * @param [options] The optional parameters
   * @returns Promise<Models.IdentityTheftMonitoringSubscriptionGetCompleteSubscriberProfileResponse>
   */
  getCompleteSubscriberProfile(options?: coreHttp.RequestOptionsBase): Promise<Models.IdentityTheftMonitoringSubscriptionGetCompleteSubscriberProfileResponse>;
  /**
   * @param callback The callback
   */
  getCompleteSubscriberProfile(callback: coreHttp.ServiceCallback<Models.CompleteSubscriberProfileApiResponse>): void;
  /**
   * @param options The optional parameters
   * @param callback The callback
   */
  getCompleteSubscriberProfile(options: coreHttp.RequestOptionsBase, callback: coreHttp.ServiceCallback<Models.CompleteSubscriberProfileApiResponse>): void;
  getCompleteSubscriberProfile(options?: coreHttp.RequestOptionsBase | coreHttp.ServiceCallback<Models.CompleteSubscriberProfileApiResponse>, callback?: coreHttp.ServiceCallback<Models.CompleteSubscriberProfileApiResponse>): Promise<Models.IdentityTheftMonitoringSubscriptionGetCompleteSubscriberProfileResponse> {
    return this.client.sendOperationRequest(
      {
        options
      },
      getCompleteSubscriberProfileOperationSpec,
      callback) as Promise<Models.IdentityTheftMonitoringSubscriptionGetCompleteSubscriberProfileResponse>;
  }

  /**
   * Relies on SDS and CosmosDB to check for subscriber onboarding status.
   * @summary Retrieves the subscriber onboarding status for the current user.
   * @param [options] The optional parameters
   * @returns
   * Promise<Models.IdentityTheftMonitoringSubscriptionGetSubscriberOnboardingStatusResponse>
   */
  getSubscriberOnboardingStatus(options?: coreHttp.RequestOptionsBase): Promise<Models.IdentityTheftMonitoringSubscriptionGetSubscriberOnboardingStatusResponse>;
  /**
   * @param callback The callback
   */
  getSubscriberOnboardingStatus(callback: coreHttp.ServiceCallback<Models.SubscriberOnboardingStatusApiResponse>): void;
  /**
   * @param options The optional parameters
   * @param callback The callback
   */
  getSubscriberOnboardingStatus(options: coreHttp.RequestOptionsBase, callback: coreHttp.ServiceCallback<Models.SubscriberOnboardingStatusApiResponse>): void;
  getSubscriberOnboardingStatus(options?: coreHttp.RequestOptionsBase | coreHttp.ServiceCallback<Models.SubscriberOnboardingStatusApiResponse>, callback?: coreHttp.ServiceCallback<Models.SubscriberOnboardingStatusApiResponse>): Promise<Models.IdentityTheftMonitoringSubscriptionGetSubscriberOnboardingStatusResponse> {
    return this.client.sendOperationRequest(
      {
        options
      },
      getSubscriberOnboardingStatusOperationSpec,
      callback) as Promise<Models.IdentityTheftMonitoringSubscriptionGetSubscriberOnboardingStatusResponse>;
  }

  /**
   * Calls external APIs to return the subscription profile.
   * @summary Retrieves the subscription profile registered for the current user.
   * @param [options] The optional parameters
   * @returns Promise<Models.IdentityTheftMonitoringSubscriptionGetSubscriberProfileResponse>
   */
  getSubscriberProfile(options?: coreHttp.RequestOptionsBase): Promise<Models.IdentityTheftMonitoringSubscriptionGetSubscriberProfileResponse>;
  /**
   * @param callback The callback
   */
  getSubscriberProfile(callback: coreHttp.ServiceCallback<Models.SubscriberProfileApiResponse>): void;
  /**
   * @param options The optional parameters
   * @param callback The callback
   */
  getSubscriberProfile(options: coreHttp.RequestOptionsBase, callback: coreHttp.ServiceCallback<Models.SubscriberProfileApiResponse>): void;
  getSubscriberProfile(options?: coreHttp.RequestOptionsBase | coreHttp.ServiceCallback<Models.SubscriberProfileApiResponse>, callback?: coreHttp.ServiceCallback<Models.SubscriberProfileApiResponse>): Promise<Models.IdentityTheftMonitoringSubscriptionGetSubscriberProfileResponse> {
    return this.client.sendOperationRequest(
      {
        options
      },
      getSubscriberProfileOperationSpec,
      callback) as Promise<Models.IdentityTheftMonitoringSubscriptionGetSubscriberProfileResponse>;
  }

  /**
   * Calls external APIs to update the subscriber's data.
   * @summary Updates the current user's subscription profile.
   * @param [options] The optional parameters
   * @returns Promise<Models.IdentityTheftMonitoringSubscriptionUpdateSubscriberProfileResponse>
   */
  updateSubscriberProfile(options?: Models.IdentityTheftMonitoringSubscriptionUpdateSubscriberProfileOptionalParams): Promise<Models.IdentityTheftMonitoringSubscriptionUpdateSubscriberProfileResponse>;
  /**
   * @param callback The callback
   */
  updateSubscriberProfile(callback: coreHttp.ServiceCallback<Models.UpdateSubscriberProfileApiResponse>): void;
  /**
   * @param options The optional parameters
   * @param callback The callback
   */
  updateSubscriberProfile(options: Models.IdentityTheftMonitoringSubscriptionUpdateSubscriberProfileOptionalParams, callback: coreHttp.ServiceCallback<Models.UpdateSubscriberProfileApiResponse>): void;
  updateSubscriberProfile(options?: Models.IdentityTheftMonitoringSubscriptionUpdateSubscriberProfileOptionalParams | coreHttp.ServiceCallback<Models.UpdateSubscriberProfileApiResponse>, callback?: coreHttp.ServiceCallback<Models.UpdateSubscriberProfileApiResponse>): Promise<Models.IdentityTheftMonitoringSubscriptionUpdateSubscriberProfileResponse> {
    return this.client.sendOperationRequest(
      {
        options
      },
      updateSubscriberProfileOperationSpec,
      callback) as Promise<Models.IdentityTheftMonitoringSubscriptionUpdateSubscriberProfileResponse>;
  }

  /**
   * Updates itm user profile settings. Currently supports only ShowCreditScore prop
   * @summary Updates the current user's subscription profile settings.
   * @param [options] The optional parameters
   * @returns Promise<coreHttp.RestResponse>
   */
  updateSubscriberProfileSettings(options?: Models.IdentityTheftMonitoringSubscriptionUpdateSubscriberProfileSettingsOptionalParams): Promise<coreHttp.RestResponse>;
  /**
   * @param callback The callback
   */
  updateSubscriberProfileSettings(callback: coreHttp.ServiceCallback<void>): void;
  /**
   * @param options The optional parameters
   * @param callback The callback
   */
  updateSubscriberProfileSettings(options: Models.IdentityTheftMonitoringSubscriptionUpdateSubscriberProfileSettingsOptionalParams, callback: coreHttp.ServiceCallback<void>): void;
  updateSubscriberProfileSettings(options?: Models.IdentityTheftMonitoringSubscriptionUpdateSubscriberProfileSettingsOptionalParams | coreHttp.ServiceCallback<void>, callback?: coreHttp.ServiceCallback<void>): Promise<coreHttp.RestResponse> {
    return this.client.sendOperationRequest(
      {
        options
      },
      updateSubscriberProfileSettingsOperationSpec,
      callback);
  }

  /**
   * Calls external APIs to delete the subscriber's cyber data elements
   * @summary Deletes the current user's cyber data elements.
   * @param [options] The optional parameters
   * @returns Promise<coreHttp.RestResponse>
   */
  deleteCyberDataElements(options?: Models.IdentityTheftMonitoringSubscriptionDeleteCyberDataElementsOptionalParams): Promise<coreHttp.RestResponse>;
  /**
   * @param callback The callback
   */
  deleteCyberDataElements(callback: coreHttp.ServiceCallback<void>): void;
  /**
   * @param options The optional parameters
   * @param callback The callback
   */
  deleteCyberDataElements(options: Models.IdentityTheftMonitoringSubscriptionDeleteCyberDataElementsOptionalParams, callback: coreHttp.ServiceCallback<void>): void;
  deleteCyberDataElements(options?: Models.IdentityTheftMonitoringSubscriptionDeleteCyberDataElementsOptionalParams | coreHttp.ServiceCallback<void>, callback?: coreHttp.ServiceCallback<void>): Promise<coreHttp.RestResponse> {
    return this.client.sendOperationRequest(
      {
        options
      },
      deleteCyberDataElementsOperationSpec,
      callback);
  }

  /**
   * Make sds call to delete all verifiable information.
   * @summary Deletes all verifiable information for the current user
   * @param [options] The optional parameters
   * @returns Promise<coreHttp.RestResponse>
   */
  deleteAllVerifiableInfo(options?: coreHttp.RequestOptionsBase): Promise<coreHttp.RestResponse>;
  /**
   * @param callback The callback
   */
  deleteAllVerifiableInfo(callback: coreHttp.ServiceCallback<void>): void;
  /**
   * @param options The optional parameters
   * @param callback The callback
   */
  deleteAllVerifiableInfo(options: coreHttp.RequestOptionsBase, callback: coreHttp.ServiceCallback<void>): void;
  deleteAllVerifiableInfo(options?: coreHttp.RequestOptionsBase | coreHttp.ServiceCallback<void>, callback?: coreHttp.ServiceCallback<void>): Promise<coreHttp.RestResponse> {
    return this.client.sendOperationRequest(
      {
        options
      },
      deleteAllVerifiableInfoOperationSpec,
      callback);
  }

  /**
   * Calls external APIs to calculate which data types are registered for CyberAgent monitoring and
   * which are not based on the current user's complete subscription profile.
   * @summary Calculates CyberAgent monitored and unmonitored data types for the current user.
   * @param [options] The optional parameters
   * @returns Promise<Models.IdentityTheftMonitoringSubscriptionGetMonitoredDataTypesResponse>
   */
  getMonitoredDataTypes(options?: coreHttp.RequestOptionsBase): Promise<Models.IdentityTheftMonitoringSubscriptionGetMonitoredDataTypesResponse>;
  /**
   * @param callback The callback
   */
  getMonitoredDataTypes(callback: coreHttp.ServiceCallback<Models.GetMonitoredDataTypesApiResponse>): void;
  /**
   * @param options The optional parameters
   * @param callback The callback
   */
  getMonitoredDataTypes(options: coreHttp.RequestOptionsBase, callback: coreHttp.ServiceCallback<Models.GetMonitoredDataTypesApiResponse>): void;
  getMonitoredDataTypes(options?: coreHttp.RequestOptionsBase | coreHttp.ServiceCallback<Models.GetMonitoredDataTypesApiResponse>, callback?: coreHttp.ServiceCallback<Models.GetMonitoredDataTypesApiResponse>): Promise<Models.IdentityTheftMonitoringSubscriptionGetMonitoredDataTypesResponse> {
    return this.client.sendOperationRequest(
      {
        options
      },
      getMonitoredDataTypesOperationSpec,
      callback) as Promise<Models.IdentityTheftMonitoringSubscriptionGetMonitoredDataTypesResponse>;
  }

  /**
   * Calls external APIs to register a credit monitoring subscriber for the user.
   * @summary Registers a credit monitoring subscriber for the ITM user based on the information
   * provided in the user claims.
   * @param [options] The optional parameters
   * @returns
   * Promise<Models.IdentityTheftMonitoringSubscriptionRegisterCreditMonitoringSubscriberResponse>
   */
  registerCreditMonitoringSubscriber(options?: coreHttp.RequestOptionsBase): Promise<Models.IdentityTheftMonitoringSubscriptionRegisterCreditMonitoringSubscriberResponse>;
  /**
   * @param callback The callback
   */
  registerCreditMonitoringSubscriber(callback: coreHttp.ServiceCallback<Models.RegisterCreditMonitoringSubscriberApiResponse>): void;
  /**
   * @param options The optional parameters
   * @param callback The callback
   */
  registerCreditMonitoringSubscriber(options: coreHttp.RequestOptionsBase, callback: coreHttp.ServiceCallback<Models.RegisterCreditMonitoringSubscriberApiResponse>): void;
  registerCreditMonitoringSubscriber(options?: coreHttp.RequestOptionsBase | coreHttp.ServiceCallback<Models.RegisterCreditMonitoringSubscriberApiResponse>, callback?: coreHttp.ServiceCallback<Models.RegisterCreditMonitoringSubscriberApiResponse>): Promise<Models.IdentityTheftMonitoringSubscriptionRegisterCreditMonitoringSubscriberResponse> {
    return this.client.sendOperationRequest(
      {
        options
      },
      registerCreditMonitoringSubscriberOperationSpec,
      callback) as Promise<Models.IdentityTheftMonitoringSubscriptionRegisterCreditMonitoringSubscriberResponse>;
  }

  /**
   * Calls external APIs to return the oauth token.
   * @summary Retrieves Experian Oauth token to call KeyRequestService.
   * @param [options] The optional parameters
   * @returns Promise<Models.IdentityTheftMonitoringSubscriptionGetEncryptionAuthTokenResponse>
   */
  getEncryptionAuthToken(options?: coreHttp.RequestOptionsBase): Promise<Models.IdentityTheftMonitoringSubscriptionGetEncryptionAuthTokenResponse>;
  /**
   * @param callback The callback
   */
  getEncryptionAuthToken(callback: coreHttp.ServiceCallback<Models.GetEncryptionAuthTokenApiResponse>): void;
  /**
   * @param options The optional parameters
   * @param callback The callback
   */
  getEncryptionAuthToken(options: coreHttp.RequestOptionsBase, callback: coreHttp.ServiceCallback<Models.GetEncryptionAuthTokenApiResponse>): void;
  getEncryptionAuthToken(options?: coreHttp.RequestOptionsBase | coreHttp.ServiceCallback<Models.GetEncryptionAuthTokenApiResponse>, callback?: coreHttp.ServiceCallback<Models.GetEncryptionAuthTokenApiResponse>): Promise<Models.IdentityTheftMonitoringSubscriptionGetEncryptionAuthTokenResponse> {
    return this.client.sendOperationRequest(
      {
        options
      },
      getEncryptionAuthTokenOperationSpec,
      callback) as Promise<Models.IdentityTheftMonitoringSubscriptionGetEncryptionAuthTokenResponse>;
  }
}

// Operation Specifications
const serializer = new coreHttp.Serializer(Mappers);
const registerSubscriberOperationSpec: coreHttp.OperationSpec = {
  httpMethod: "POST",
  path: "api/v1/IdentityTheftMonitoring/Subscription",
  responses: {
    200: {
      bodyMapper: Mappers.RegisterSubscriberApiResponse
    },
    201: {
      bodyMapper: Mappers.RegisterSubscriberApiResponse
    },
    default: {
      bodyMapper: Mappers.ConsumerSecurityErrorResponse
    }
  },
  serializer
};

const deleteSubscriberOperationSpec: coreHttp.OperationSpec = {
  httpMethod: "DELETE",
  path: "api/v1/IdentityTheftMonitoring/Subscription",
  queryParameters: [
    Parameters.forceDelete
  ],
  responses: {
    204: {},
    default: {
      bodyMapper: Mappers.ConsumerSecurityErrorResponse
    }
  },
  serializer
};

const registerSubscriberWithPrimaryDataOperationSpec: coreHttp.OperationSpec = {
  httpMethod: "POST",
  path: "api/v1/IdentityTheftMonitoring/Subscription/register/primary",
  requestBody: {
    parameterPath: [
      "options",
      "body"
    ],
    mapper: Mappers.RegisterSubscriberWithPrimaryDataRequest
  },
  contentType: "application/json-patch+json; charset=utf-8",
  responses: {
    200: {
      bodyMapper: Mappers.RegisterSubscriberApiResponse
    },
    201: {
      bodyMapper: Mappers.RegisterSubscriberApiResponse
    },
    default: {
      bodyMapper: Mappers.ConsumerSecurityErrorResponse
    }
  },
  serializer
};

const onboardingCompletedOperationSpec: coreHttp.OperationSpec = {
  httpMethod: "POST",
  path: "api/v1/IdentityTheftMonitoring/Subscription/onboarding/completed",
  responses: {
    200: {},
    default: {
      bodyMapper: Mappers.ConsumerSecurityErrorResponse
    }
  },
  serializer
};

const getSubscriberOnboardingSummaryOperationSpec: coreHttp.OperationSpec = {
  httpMethod: "GET",
  path: "api/v1/IdentityTheftMonitoring/Subscription/onboarding/summary",
  responses: {
    200: {
      bodyMapper: Mappers.SubscriberOnboardingSummaryApiResponse
    },
    default: {
      bodyMapper: Mappers.ConsumerSecurityErrorResponse
    }
  },
  serializer
};

const getCompleteSubscriberProfileOperationSpec: coreHttp.OperationSpec = {
  httpMethod: "GET",
  path: "api/v1/IdentityTheftMonitoring/Subscription/profile/complete",
  responses: {
    200: {
      bodyMapper: Mappers.CompleteSubscriberProfileApiResponse
    },
    default: {
      bodyMapper: Mappers.ConsumerSecurityErrorResponse
    }
  },
  serializer
};

const getSubscriberOnboardingStatusOperationSpec: coreHttp.OperationSpec = {
  httpMethod: "GET",
  path: "api/v1/IdentityTheftMonitoring/Subscription/profile/onboarding/status",
  responses: {
    200: {
      bodyMapper: Mappers.SubscriberOnboardingStatusApiResponse
    },
    default: {
      bodyMapper: Mappers.ConsumerSecurityErrorResponse
    }
  },
  serializer
};

const getSubscriberProfileOperationSpec: coreHttp.OperationSpec = {
  httpMethod: "GET",
  path: "api/v1/IdentityTheftMonitoring/Subscription/profile",
  responses: {
    200: {
      bodyMapper: Mappers.SubscriberProfileApiResponse
    },
    default: {
      bodyMapper: Mappers.ConsumerSecurityErrorResponse
    }
  },
  serializer
};

const updateSubscriberProfileOperationSpec: coreHttp.OperationSpec = {
  httpMethod: "PATCH",
  path: "api/v1/IdentityTheftMonitoring/Subscription/profile",
  requestBody: {
    parameterPath: [
      "options",
      "body"
    ],
    mapper: Mappers.UpdateSubscriberRequest
  },
  contentType: "application/json-patch+json; charset=utf-8",
  responses: {
    200: {
      bodyMapper: Mappers.UpdateSubscriberProfileApiResponse
    },
    default: {
      bodyMapper: Mappers.ConsumerSecurityErrorResponse
    }
  },
  serializer
};

const updateSubscriberProfileSettingsOperationSpec: coreHttp.OperationSpec = {
  httpMethod: "PATCH",
  path: "api/v1/IdentityTheftMonitoring/Subscription/profile/settings",
  requestBody: {
    parameterPath: [
      "options",
      "body"
    ],
    mapper: Mappers.ItmUserProfilePatchRequest
  },
  contentType: "application/json-patch+json; charset=utf-8",
  responses: {
    200: {},
    default: {
      bodyMapper: Mappers.ConsumerSecurityErrorResponse
    }
  },
  serializer
};

const deleteCyberDataElementsOperationSpec: coreHttp.OperationSpec = {
  httpMethod: "DELETE",
  path: "api/v1/IdentityTheftMonitoring/Subscription/profile/cyberdata",
  requestBody: {
    parameterPath: [
      "options",
      "body"
    ],
    mapper: Mappers.DeleteSubscriberCyberDataRequest
  },
  contentType: "application/json-patch+json; charset=utf-8",
  responses: {
    204: {},
    default: {
      bodyMapper: Mappers.ConsumerSecurityErrorResponse
    }
  },
  serializer
};

const deleteAllVerifiableInfoOperationSpec: coreHttp.OperationSpec = {
  httpMethod: "DELETE",
  path: "api/v1/IdentityTheftMonitoring/Subscription/profile/verifiableinfo",
  responses: {
    204: {},
    default: {
      bodyMapper: Mappers.ConsumerSecurityErrorResponse
    }
  },
  serializer
};

const getMonitoredDataTypesOperationSpec: coreHttp.OperationSpec = {
  httpMethod: "GET",
  path: "api/v1/IdentityTheftMonitoring/Subscription/profile/cyberdata/types",
  responses: {
    200: {
      bodyMapper: Mappers.GetMonitoredDataTypesApiResponse
    },
    default: {
      bodyMapper: Mappers.ConsumerSecurityErrorResponse
    }
  },
  serializer
};

const registerCreditMonitoringSubscriberOperationSpec: coreHttp.OperationSpec = {
  httpMethod: "POST",
  path: "api/v1/IdentityTheftMonitoring/Subscription/Credit/register",
  responses: {
    200: {
      bodyMapper: Mappers.RegisterCreditMonitoringSubscriberApiResponse
    },
    default: {
      bodyMapper: Mappers.ConsumerSecurityErrorResponse
    }
  },
  serializer
};

const getEncryptionAuthTokenOperationSpec: coreHttp.OperationSpec = {
  httpMethod: "GET",
  path: "api/v1/IdentityTheftMonitoring/Subscription/encryption/oauth/token",
  responses: {
    200: {
      bodyMapper: Mappers.GetEncryptionAuthTokenApiResponse
    },
    default: {
      bodyMapper: Mappers.ConsumerSecurityErrorResponse
    }
  },
  serializer
};
